export const SM_SIZE_TOKENS = {
  fontSize: '0.8125rem', // 13px
  paddingY: '0.328125rem', // 5.25px
  paddingX: '0.546875rem', // 8.75px
} as const;
